import { render, staticRenderFns } from "./PayrollReconciliation.vue?vue&type=template&id=64c2ed04&scoped=true"
import script from "./PayrollReconciliation.vue?vue&type=script&lang=js"
export * from "./PayrollReconciliation.vue?vue&type=script&lang=js"
import style0 from "./PayrollReconciliation.vue?vue&type=style&index=0&id=64c2ed04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c2ed04",
  null
  
)

export default component.exports